
export default {
  props: ["shippings", "cart", "active", "noMedia", "exclude"],
};
